import React, { useEffect, useState } from "react";
import axios from "axios";
import { URL_API } from "../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Pagination,
} from "reactstrap";
import moment from "moment";

import ReactPaginate from "react-paginate";
import { useParams } from "react-router";

function TransferHistory() {
  const loaderCss = css`
    margin: auto;
  `;
  const [customers, setCustomers] = useState([]);
  const [loading, setloading] = useState([]);

  const [offset, setOffset] = useState(0);
  const [perPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const userId = useParams();
  console.log("userId", userId);

  useEffect(() => {
    getCustomers();
    setloading(true);
  }, []);

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage + 1);
  };

  const getCustomers = () => {
    axios
      .get(URL_API + `app/transaction/userEwalletHistory?id=${userId.id}`)
      .then((response) => {
        console.log("refereddfafasdfasdfads", response.data.data);
        if (response.request.status == 202) {
          setCustomers(response.data.data);
          console.log("inside customers", response.data.data);

          // setloading(false);
        }
      });
  };
  console.log("custsddsdomers", customers);

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Transfer History</CardTitle>
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th>Amount</th>
                      <th>Transfer TO</th>
                      <th>Transfer By</th>
                      <th>Created At</th>
                      {/* <th className="text-right">Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {customers?.map((transfers, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{transfers?.amount}</td>
                          <td>{transfers?.transfer_to.name}</td>
                          {/* <td>Example   20 Rs</td>
                                        <td>Example   1000 Rs</td>
                                        <td>Child User Name</td> */}
                          <td>{transfers?.transfer_by.name}</td>
                          <td>
                            {moment(transfers?.created_at).format(
                              " DD MMMM YYYY, h:mm a"
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                {/* <ReactPaginate
                    previousLabel={"prev"}
                    nextLabel={"next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}/> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default TransferHistory;
